/*
 * @Description state 数据文件
 * @Author: fiveonelei
 * @Date: 2022-01-14 18:17:57
 * @FilePath: /app-monorepo-projects/packages/app-share/src/store/state.ts
 */
import { DEFAULT_GROWTHTEST_DATA } from '@/constants/share';
import { GROWTH_POPUP } from '@/constants/ab-test';
import { ModelCollectionInfo, ModelMetaFeed } from '@/types/model';
import { FetchShareStrategyResult } from '@/types/services/fetch-share-strategy';
import { ZzConfig } from '@/types/services/fetch-zz-config';
import { ShareUi } from '@/types/share';
import { MetaBanner } from '@/types/banner';
import { Drama } from '@/types/drama';

export interface State {
  collectionInfo: ModelCollectionInfo | null,
  feedsList: ModelMetaFeed[],
  showCollection: boolean,
  isCollection: boolean,
  isDrama: boolean,
  activeIndex: number,
  shareUi: ShareUi | null;
  activePlayerPlaying: boolean,
  isNewUI: boolean,
  zzConfig: ZzConfig | null,
  isInstall: boolean | null,
  growthTestData: FetchShareStrategyResult | null,
  banner: MetaBanner | null,
  errorMsg: string,
  isGrowthPopup: string,
  dramaList: Drama[],
  showHandTip: boolean,
  isFullScreen: boolean,
  isNewPage: boolean,
}

export default function state(): State {
  return {
    collectionInfo: null,
    feedsList: [],
    isCollection: false,
    isDrama: false,
    showCollection: false,
    activeIndex: 0,
    shareUi: null,
    activePlayerPlaying: false,
    isNewUI: false,
    zzConfig: null,
    isInstall: null,
    growthTestData: DEFAULT_GROWTHTEST_DATA,
    banner: null,
    errorMsg: '',
    isGrowthPopup: GROWTH_POPUP.YES,
    dramaList: [],
    showHandTip: false,
    isFullScreen: false,
    isNewPage: false,
  };
}
